import { defineStore } from 'pinia';
import type { TokenType, userType, AuthResponse } from '@/types/common';
import { ref, computed } from 'vue';
import { userClassApp } from '@/utils/getAuth';
import axios from '@/plugins/axios';
import { useDataStore } from '@/store/dataStore';

export const useAuthStore = defineStore('authStore', () => {
  const dataStore = useDataStore();
  const userStore = ref<userType | null>(null);
  const accessToken = ref<string | null>(null);
  const refreshToken = ref<string | null>(null);
  const socket = ref<WebSocket | null>(null);

  const getUser = computed((): userType | null => userStore.value);

  function setTokens(tokens: AuthResponse) {
    accessToken.value = tokens.access_token;
    refreshToken.value = tokens.refresh_token;
  }

  const setUser = (userData: userType | null, stayLoggined?: boolean) => {
    userStore.value = userData;
    if (userData) {
      if (stayLoggined) {
        localStorage.setItem('authPacker', JSON.stringify(userData));
      }
      userClassApp.setUser(userData);
    } else {
      localStorage.removeItem('authPacker');
      userClassApp.setUser(null);
    }
  };

  function logout() {
    if (socket.value) {
      socket.value.close();
      socket.value = null;
    }
    accessToken.value = null;
    refreshToken.value = null;
    userStore.value = null;
    delete axios.defaults.headers.common['Authorization'];
    localStorage.removeItem('authPacker');
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('calculation_id');
    dataStore.reset();
  }

  return {
    userStore,
    getUser,
    accessToken,
    refreshToken,
    socket,
    setTokens,
    setUser,
    logout,
  };
});
